
export function formatDateRange(start, end) {
    const startDate = new Date(start);
    const endDate = end ? new Date(end) : startDate;
    const days = Math.max(1, Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1);
    const sd = startDate.toLocaleDateString("en-GB")
    const ed = endDate.toLocaleDateString("en-GB")
    return ({start:sd, end:ed, duration:days});
};
